import { render, staticRenderFns } from "./UpdScan.vue?vue&type=template&id=1fe49e68"
import script from "./UpdScan.vue?vue&type=script&lang=js"
export * from "./UpdScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports